import React, { ReactNode } from "react";
import styled from "styled-components";

interface IBackground {
  repeat: boolean;
  fixed: boolean;
  src?: string;
  backgroundColor?: string;
  headerHeight?: number | null;
}

const Wrapper = styled.div<IBackground>`
  background-image: ${({ src }: IBackground): string =>
    src ? `url(${src})` : "none"};
  background-color: ${({ backgroundColor }: IBackground): string =>
    backgroundColor ? backgroundColor : "initial"};

  background-repeat: ${({ repeat }: IBackground): string =>
    repeat ? "repeat-y" : "no-repeat"};
  background-attachment: ${({ fixed }: IBackground): string =>
    fixed ? "fixed" : "initial"};

  // By default, position is "center top",
  // when background is fixed, "50% -46%" is similar
  background-position: ${({ fixed }: IBackground): string =>
    fixed ? "50% -50%" : "center top"};

  // By default, 146px of spacing on top
  padding-top: ${({ headerHeight }: IBackground): number =>
    headerHeight !== null && headerHeight !== undefined ? headerHeight : 146}px;

  // Show cursor pointer, only on background, not on nested elements
  cursor: pointer;

  & > * {
    cursor: initial;
  }
`;

interface IProps {
  children: ReactNode;
  to: string;
  repeat: boolean;
  fixed: boolean;
  className?: string;
  src?: string;
  backgroundColor?: string;
  headerHeight?: number | null;
}

const RenderBackground = ({
  to,
  children,
  src,
  backgroundColor,
  headerHeight,
  repeat,
  fixed,
}: IProps): JSX.Element => {
  const handleClick = (
    e: React.MouseEvent<HTMLDivElement, MouseEvent>
  ): void => {
    const target = e.target as HTMLDivElement;

    if (target.id !== "banner-background-link") {
      e.preventDefault();

      return;
    }

    window.location.assign(to);
  };

  return (
    <Wrapper
      id="banner-background-link"
      src={src}
      headerHeight={headerHeight}
      backgroundColor={backgroundColor}
      repeat={repeat}
      fixed={fixed}
      onClick={handleClick}
    >
      {children}
    </Wrapper>
  );
};

export default RenderBackground;
